import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  Employee,
  CreateOrUpdateEmployee,
  ResetPassword,
  LookupModel,
} from '../models';
import { HttpParams } from '@angular/common/http';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
  url = '/employees';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<Employee>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: string): Observable<Employee> {
    const params = new HttpParams().set('id', id.toString());
    return this.apiService.get(this.url, params).pipe(map(data => data.data));
  }

  create(model: CreateOrUpdateEmployee): Observable<void> {
    return this.apiService.post(this.url, model);
  }

  update(id: number, model: CreateOrUpdateEmployee): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model);
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id.toString()}`);
  }

  isUserNameExists(username: string, userId: string): Observable<boolean> {
    return this.apiService
      .get(`/users/username-exists/${username}/${userId}`)
      .pipe(map(data => data.data));
  }

  isEmailExists(email: string, userId: string): Observable<boolean> {
    return this.apiService
      .get(`/users/email-exists/${email}/${userId}`)
      .pipe(map(data => data.data));
  }

  resetPassword(model: ResetPassword): Observable<void> {
    return this.apiService.post(`/users/reset-password`, model);
  }
}
